<table class="table">
    <thead>
        <tr>
            <th *ngFor="let col of columns">
                {{ col.key | translate }}
            </th>
            <th>
                ACCIONES
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of data">
            <td *ngFor="let col of columns">
                {{ item[col.field] }}
            </td>
            <td class="actions-buttons">
                <button *ngIf="actions.includes('edit')" class="btn btn-primary" (click)="editAction(item)">
                    Editar
                </button>
                <button *ngIf="actions.includes('delete')"  class="btn btn-danger" (click)="deleteAction(item)">
                    Eliminar
                </button>
                <button *ngIf="actions.includes('see-products')" class="btn btn-success" (click)="seeProductsAction(item)">
                    Ver Productos
                </button>
                <button *ngIf="actions.includes('see-store')" class="btn btn-success" (click)="seeProductsAction(item)">
                    Ver Centro
                </button>
            </td>
        </tr>
    </tbody>
</table>
